<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("VFR Charts") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      v-for="position in vfrChartsSortByIndexAscending"
      :key="position"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-20"
    >
      <product-card>
        <div slot="imageHeader" class="viewer" @click="show(position)">
          <img
            class="img"
            :id="'img' + position"
            :src="
              BLOB_URL +
                '/img/vfr/thumbnails/' +
                vfrChartFiles[position] +
                '.jpg'
            "
          />
        </div>
        <div slot="description" class="card-description text-primary">
          {{ vfrCharts[position] }}
        </div>
      </product-card>
    </div>
  </div>
</template>
<script>
import { vfrCharts, vfrChartFiles } from "../../const";
import { ProductCard } from "@/components";
import Viewer from "viewerjs";
import { BLOB_URL } from "@/helpers";

export default {
  components: {
    ProductCard
  },
  computed: {},
  data() {
    return {
      BLOB_URL: BLOB_URL,
      vfrChartsSortByIndexAscending: this.sortByIndexAscending(vfrCharts),
      vfrCharts,
      vfrChartFiles: vfrChartFiles,
      viewer: undefined
    };
  },
  methods: {
    show(position) {
      var image = document.getElementById("img" + position);
      var url = this.BLOB_URL + "/img/vfr/" + vfrChartFiles[position] + ".png";
      this.viewer = new Viewer(image, {
        navbar: false,
        toolbar: false,
        url() {
          return url;
        }
      });
      this.viewer.show();
    },
    sortByIndexAscending(arr) {
      var indexArray = Array.from(arr.keys());

      indexArray.sort(function(a, b) {
        return arr[a].localeCompare(arr[b]);
      });
      return indexArray;
    }
  },
  destroyed() {
    if (this.viewer !== undefined) {
      this.viewer.destroy();
    }
  }
};
</script>

<style lang="css" scoped>
.viewer {
  cursor: pointer;
}
</style>
